<div class="form-group">
  <app-input
    [(ngModel)]="model"
    [type]="type"
    [step]="step"
    [maxFractionDigits]="maxFractionDigits"
    [decimalSeparator]="decimalSeparator"
    [disabled]="disabled"
    (ngModelChange)="modelChange.emit(model)"
    (onDecimalSeparatorUsed)="onDecimalSeparatorUsed.emit($event)"
    (onSeparatorMismatch)="onSeparatorMismatch.emit($event)"
    [placeholder]="placeholder"
    [label]="label"
    (onBlur)="onBlur.emit($event)"
    [min]="min"
  ></app-input>
</div>
